<template>
<app-layout>
 
  
  <jet-authentication-card>

    <div class="card-body text-center">

      <div class="alert alert-success text-center" v-if="$page.props.user">
        Authentication Success
      </div>
      <div class="alert alert-danger text-center" v-else>Authentication Failed</div>

      <img src="https://s3.eu-west-3.amazonaws.com/expopolis-ecommerce/logos/aa4079ad95d535c7ef32e895feb02647.jpeg" style="max-width:150px;" class="img-fluid img-thumbnail"/>

      <div v-if="$page.props.user" class="py-3">
      <h5>Welcome, {{$page.props.user.name}}<br/></h5>
      <br/>
      <inertia-link v-if="$page.props.user.is_supplier" :href="route('admin.setting')" class="btn btn-secondary hvr-float rounded-0">Manage Store</inertia-link>
      <inertia-link v-else :href="route('products')" class="btn btn-secondary hvr-float rounded-0">Start Browse Product</inertia-link>
      </div>
      

    </div>
  </jet-authentication-card>
</app-layout>
</template>

<script>
import JetAuthenticationCard from '@/Jetstream/AuthenticationCard'
import JetAuthenticationCardLogo from '@/Jetstream/AuthenticationCardLogo'
import JetButton from '@/Jetstream/Button'
import JetInput from '@/Jetstream/Input'
import JetCheckbox from '@/Jetstream/Checkbox'
import JetLabel from '@/Jetstream/Label'
import JetValidationErrors from '@/Jetstream/ValidationErrors'
import AppLayout from '@/Layouts/AppLayout'


export default {
  components: {
    JetAuthenticationCard,
    JetAuthenticationCardLogo,
    JetButton,
    JetInput,
    JetCheckbox,
    JetLabel,
    JetValidationErrors,
    AppLayout
  },

  props: {
    "user": Array
  }

}
</script>
